import Api from "../../lib/api";

export default class LoadMore {
	constructor(props = {}) {
		this.$root = props.$root || document.querySelector('[data-more="root"]');
		this.$trigger = props.$trigger || document.querySelector('[data-more="trigger"]');
		this.$items = null;

		this.callback = props.callback || null;

		this.url = props.url || null;
		this.offset = 0;

		this.init();
	}

	init() {
		if (!this.$root) {
			throw new Error('LoadMore: Root element is not defined!');
		}

		if (!this.$trigger) {
			throw new Error('LoadMore: Trigger element is not defined!');
		}

		this.$items = this.$root.querySelectorAll('[data-more="item"]');

		if (this.$root.dataset && this.$root.dataset.url) {
			this.url = this.$root.dataset.url;
		}

		if (!this.url) {
			throw new Error('LoadMore: url is missing!');
		}

		this.addEventListeners();
	}

	addEventListeners() {
		this.$trigger.addEventListener('click', () => {
			this.loadHtml();
		});
	}

	loadHtml() {
		this.offset = this.$items.length;
		this.$trigger.classList.add('-loading');

		Api.get(this.url, { offset: this.offset }).then((data) => {
			data = data.trim();

			if (data) {
				this.$root.insertAdjacentHTML('beforeend', data);
				this.$items = this.$root.querySelectorAll('[data-more="item"]');

				if (this.callback) {
					this.callback();
				}
			} else {
				this.$trigger.remove();
			}

			this.$trigger.classList.remove('-loading');
		});
	}
}